export default function orderingTableOrderNumber(order) {
    if (order?.order_number) {
        return String(order.order_number);
    }

    const pickupNumber = order?.pickup_number;
    if (pickupNumber === null || pickupNumber === undefined || pickupNumber === "") {
        return null;
    }

    const number = Number(pickupNumber);
    return Number.isSafeInteger(number) && number > 0 ? String(number).padStart(3, "0") : null;
}
